
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BackButton } from "@/components/onboarding/BackButton";

const PaymentMethods = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleNextStep = () => {
    setIsLoading(true);
    // Navigate to the next step without saving any payment methods
    setTimeout(() => {
      setIsLoading(false);
      navigate('/social-links');
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <Header />
      <div className="container mx-auto px-4 py-24 max-w-2xl">
        <div className="flex justify-center mb-12">
          <div className="flex items-center gap-3">
            {[1, 2, 3, 4, 5].map((step) => (
              <div
                key={step}
                className={`w-10 h-10 rounded-full flex items-center justify-center border-2 
                  ${step === 2
                    ? "border-gebeya-pink bg-white text-gebeya-pink"
                    : step < 2
                    ? "border-gebeya-pink bg-gebeya-pink text-white"
                    : "border-gray-200 text-gray-400"
                  }`}
              >
                {step}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Payments</h1>
          <p className="text-gray-600 text-lg">
            Set up how you'll receive payments from customers
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 p-8 mb-8 text-center">
          <h2 className="text-2xl font-semibold mb-4">Coming Soon!</h2>
          <p className="text-gray-600 mb-6">
            We're working hard to bring you integrated payment solutions for your business.
            Soon, you'll be able to accept payments through Mpesa, cash, and digital wallets.
          </p>
          <div className="py-4 px-6 bg-blue-50 text-blue-700 rounded-lg inline-block">
            <span className="font-medium">Stay tuned for updates!</span>
          </div>
        </div>

        <div className="mt-12 flex gap-4">
          <Button
            onClick={() => navigate("/add-services")}
            variant="outline"
            className="h-12 flex items-center gap-2"
            size="lg"
          >
            <ChevronLeft className="h-4 w-4" />
            Back
          </Button>
          <Button
            onClick={handleNextStep}
            disabled={isLoading}
            className="h-12 flex-1 bg-gradient-to-r from-gebeya-pink to-gebeya-orange hover:opacity-90"
          >
            {isLoading ? "Processing..." : "Next"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
